import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const QuantityPurchase = ({ selectedProduct }) => {
  const [quantity, setQuantity] = useState(0);
  const [show, setShow] = useState(false);

  const allowedProducts = [4551549780055, 3820057428020, 4544861601879, 4544896139351, 4544840073303, 3818950787124];

  const { id: currentId } = selectedProduct;

  const ifAllowed = allowedProducts.find(item => item === currentId);

  const fetchData = async () => {
    try {
      const request = await fetch('https://webhooks.endrock.software/endrockapi/v3/app/canvasPrints/reportsGA4.php');
      const response = await request.json();
      const { data: { allTotalItemsPurchased } } = response;
      setQuantity(allTotalItemsPurchased);
      setTimeout(function(){
        if(window.show_variant_recent_purchaces) {
          setShow(true);
        }
      }, 800);
    } catch(error){
      setShow(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {(ifAllowed) && (show) && (
        <>
          <QuantityPurchaseRow>
            <Pulse />
            <QuantityPurchaseLabel>
              {quantity} items purchased recently
            </QuantityPurchaseLabel>
          </QuantityPurchaseRow>
        </>
      )}
    </>
  );
};

const QuantityPurchaseRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const pulseAnimation = keyframes`
0% {transform: scale(0.95);box-shadow: 0 0 0 0 rgba(90, 206, 61, 0.7);}
70% {transform: scale(1);box-shadow: 0 0 0 10px rgba(90, 206, 61, 0);}
100% {transform: scale(0.95);box-shadow: 0 0 0 0 rgba(90, 206, 61, 0);}
`;

const Pulse = styled.div`
  display: block !important;
  background: #5ACE3D;
	border-radius: 50%;
	margin: 10px;
	height: 7px;
	width: 7px;

	box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
	transform: scale(1);
  animation: ${pulseAnimation} 2s infinite;
`;

const QuantityPurchaseLabel = styled.p`
  display: block;
  color: #656565;
  font-size: 16px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
`;

export default QuantityPurchase;